import Hotspots from './hotspots.ui';

export default Hotspots;
